module.exports = __webpack_public_path__ + "static/img/activity6.c9bb31d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/activity6.jpg
// module id = dybQ
// module chunks = 0